<script setup>
import { TabButton, TabContent, Tabs } from 'dmui_components'
import LiveReportTab from './live_reports/LiveReportTab.vue'
import IroReportsTab from './iro/IroReportsTab.vue'
import ExpectedReportTab from './expected_reports/ExpectedReportTab.vue'
import { computed } from 'vue'
import permissionChecker from '@/components/permissionChecker'

defineProps({
	permission: {
		type: Array,
		default: () => []
	}
})

const { hasPermission } = permissionChecker()
const readonly = computed(() => !hasPermission('reports', 'wd'))
</script>

<template>
	<div id="report-overview">
		<Tabs default="expected-reports">
			<template #buttons>
				<TabButton name="expected-reports">Expected reports</TabButton>
				<TabButton name="live-reports">Live reports</TabButton>
				<TabButton name="iro">IRO</TabButton>
			</template>
			<TabContent name="expected-reports">
				<ExpectedReportTab :readonly="readonly" />
			</TabContent>
			<TabContent name="live-reports">
				<LiveReportTab :readonly="readonly" />
			</TabContent>
			<TabContent name="iro">
				<IroReportsTab :readonly="readonly" />
			</TabContent>
		</Tabs>
	</div>
</template>

<style scoped lang="less">
#report-overview {
	display: flex;
	flex-direction: column;
	gap: @midi;
}

:deep(.tab-content) {
	padding: @medium 0;
}

:deep(.tabs) {
	position: relative;
}
</style>
